<template>
    <DefaultHeader />

    <div class="container my-4">
        <div class="row d-flex justify-content-center">
            <div class="col-12 col-lg-10">
                <!-- Titre + progression / ou Sommaire -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h2 class="h5 mb-0">{{ pageTitle }}</h2>
                    <div v-if="currentStep !== null" class="text-muted small">Étape {{ currentStep }} / {{ totalSteps }}
                    </div>
                    <div v-else class="text-muted small">Sommaire</div>
                </div>

                <!-- SOMMAIRE par défaut -->
                <div v-if="currentStep === null" class="card shadow-sm toc-card">
                    <div class="card-body">
                        <p class="mb-3">Choisissez une section pour aller directement à l’étape correspondante :</p>
                        <ul class="list-group toc-list">
                            <li v-for="item in toc" :key="item.step"
                                class="list-group-item d-flex justify-content-between align-items-center">
                                <div class="me-3">
                                    <strong class="d-block">{{ item.title }}</strong>
                                    <small class="text-muted">{{ item.description }}</small>
                                </div>
                                <router-link class="btn btn-sm btn-primary"
                                    :to="{ name: 'MissionTutorial', params: { step: item.step } }">
                                    Aller à l’étape {{ item.step }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Carte du slide -->
                <div v-else class="card shadow-sm tutorial-card">
                    <div class="card-body">
                        <div class="tutorial-image-wrap">
                            <img class="tutorial-image" :src="currentSlide.src"
                                :alt="currentSlide.alt || ('Slide ' + currentStep)" />
                        </div>
                        <div v-if="currentSlide.title || currentSlide.text" class="mt-3">
                            <h3 v-if="currentSlide.title" class="h6 mb-1">{{ currentSlide.title }}</h3>
                            <p v-if="currentSlide.text" class="mb-0">{{ currentSlide.text }}</p>
                        </div>
                    </div>

                    <div class="card-footer bg-white d-flex justify-content-between">
                        <button class="btn btn-outline-secondary" :disabled="currentStep === 1" @click="goPrev">
                            ← Précédent
                        </button>
                        <div class="d-flex gap-2">
                            <button v-if="currentStep < totalSteps" class="btn btn-primary" @click="goNext">
                                Suivant →
                            </button>
                            <button v-else class="btn btn-success" @click="finish">
                                Terminer
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <DefaultFooter />
    <!-- Astuce: tu peux ajouter un lien vers /tutorial/1 depuis où tu veux -->
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'

export default {
    name: 'MissionTutorial',
    components: { DefaultHeader, DefaultFooter },
    props: {
        step: { type: Number, default: null }
    },
    data() {
        return {
            // Remplace ces chemins par tes vraies images (place-les dans /public/img/tutorial/…)
            slides: [
                { src: '/img/tutorial/diapositive3.png', pageTitle: 'Création / préparation de mission', title: 'Accès', text: 'Dans le menu "Fonctions sécurité", choisissez "Missions".' },
                { src: '/img/tutorial/diapositive4.png', pageTitle: 'Création / préparation de mission', title: 'Création', text: 'Cliquez sur le bouton "Nouvelle mission".' },
                { src: '/img/tutorial/diapositive5.png', pageTitle: 'Création / préparation de mission', title: 'Nom et corridoring', text: 'Choisissez le nom de la mission et le corridoring à utiliser.' },
                { src: '/img/tutorial/diapositive6.png', pageTitle: 'Création / préparation de mission', title: 'Véhicule principal', text: 'Choisissez le véhicule principal de la mission.' },
                { src: '/img/tutorial/diapositive7.png', pageTitle: 'Création / préparation de mission', title: 'Chauffeurs', text: 'Choisissez la liste des chauffeurs participant à la mission.' },
                { src: '/img/tutorial/diapositive8.png', pageTitle: 'Création / préparation de mission', title: 'Convoi', text: 'Choisissez les véhicules du convoi, possibilité d\'ajouter par groupes.' },
                { src: '/img/tutorial/diapositive9.png', pageTitle: 'Création / préparation de mission', title: 'Convoi', text: 'Contrôle des véhicules du convoi.' },
                { src: '/img/tutorial/diapositive10.png', pageTitle: 'Création / préparation de mission', title: 'Véhicules hors Argos', text: 'Ajoutez les plaques d\'immatriculation des véhicules de la mission mais non présents sur Argos (ils sont communiqués par le client).' },
                { src: '/img/tutorial/diapositive11.png', pageTitle: 'Création / préparation de mission', title: 'Vérification', text: 'Vérifiez les informations sur l\'écran récapitulatif.' },
                { src: '/img/tutorial/diapositive13.png', pageTitle: 'Démarrage de mission', title: 'Accès', text: 'Dans le menu "Fonctions sécurité", choisissez "Missions".' },
                { src: '/img/tutorial/diapositive14.png', pageTitle: 'Démarrage de mission', title: 'Ouvrir', text: 'Cliquez sur le lien dans le titre de la mission.' },
                { src: '/img/tutorial/diapositive15.png', pageTitle: 'Démarrage de mission', title: 'Vérification', text: 'Contrôlez les informations de la mission.' },
                { src: '/img/tutorial/diapositive16.png', pageTitle: 'Démarrage de mission', title: 'Contrôle du chauffeur', text: 'Vérifiez le mot de passe du chauffeur.' },
                { src: '/img/tutorial/diapositive17.png', pageTitle: 'Démarrage de mission', title: 'Tests véhicules', text: 'Effectuez les tests préalables pour chaque véhicule du convoi.' },
                { src: '/img/tutorial/diapositive18.png', pageTitle: 'Démarrage de mission', title: 'Gestion des tests', text: 'Effectuez les tests préalables pour chaque véhicule du convoi.' },
                { src: '/img/tutorial/diapositive19.png', pageTitle: 'Démarrage de mission', title: 'Cas des tests NON OK', text: 'Si les tests ne peuvent pas être validés, gérez la demander d\'autorisation spéciale.' },
                { src: '/img/tutorial/diapositive21.png', pageTitle: 'Mot de passe sous contrainte', title: 'Mot de passe sous contrainte', text: 'Lorsque la vérification du chauffeur indique qu\'il s\'agit du mot de passe sous contrainte, gérez l\'alarme en suivant la procédure.' },
                { src: '/img/tutorial/diapositive23.png', pageTitle: 'Suivi de mission en cours', title: 'Accès', text: 'Dans le menu "Fonctions sécurité", choisissez "Missions".' },
                { src: '/img/tutorial/diapositive24.png', pageTitle: 'Suivi de mission en cours', title: 'Suivi de la mission', text: 'Cliquez sur l\'icône de carte pour suivre les véhicules de la mission' },
                { src: '/img/tutorial/diapositive25.png', pageTitle: 'Suivi de mission en cours', title: 'Visualisation sur la carte', text: 'Vous pouvez visualiser les véhicules de la mission sur la carte.' },
                { src: '/img/tutorial/diapositive27.png', pageTitle: 'Terminer la mission', title: 'Accès', text: 'Dans le menu "Fonctions sécurité", choisissez "Missions".' },
                { src: '/img/tutorial/diapositive28.png', pageTitle: 'Terminer la mission', title: 'Aller à la fin de mission', text: 'Cliquez sur le lien dans le titre de la mission à terminer puis scrollez jusqu\'à la section de fin de mission.' },
                { src: '/img/tutorial/diapositive29.png', pageTitle: 'Terminer la mission', title: 'Appel du chauffeur pour terminer', text: 'Vérifiez le mot de passe du chauffeur puis choisissez un commentaire de fin de mission. Vous pouvez ensuite terminer.' }            ],
            // Sommaire : ajuster librement les intitulés/étapes
            toc: [
                { step: 1, title: 'Création / préparation de mission', description: 'Démarrer une nouvelle mission depuis l’assistant.' },
                { step: 10, title: 'Démarrer une mission lorsqu\'un chauffeur appelle', description: 'Associer le véhicule et ses informations.' },
                { step: 17, title: 'Mot de passe sous contrainte lors de l\'identification du chauffeur', description: 'Saisir et valider le code de vérification.' },
                { step: 18, title: 'Suivre une mission en cours', description: 'Contrôler les points critiques avant départ.' },
                // Exemple d’accès direct à une étape plus loin (adapter selon ton nombre de slides)
                { step: 21, title: 'Terminer une mission lorsqu\'un chauffeur appelle', description: 'Procéder au démarrage officiel.' }
            ]
        }
    },
    computed: {
        totalSteps() {
            return this.slides.length
        },
        currentStep() {
            if (this.step == null) return null
            const s = Number(this.step)
            if (isNaN(s) || s < 1) return 1
            if (s > this.totalSteps) return this.totalSteps
            return s
        },
    // Titre personnalisable par page : currentSlide.pageTitle > currentSlide.title > "Tutoriel"
    pageTitle() {
      if (this.currentStep === null) return 'Tutoriel';
      const s = this.currentSlide || {};
      return s.pageTitle || s.title || 'Tutoriel';
    },
        currentSlide() {
            return this.currentStep ? (this.slides[this.currentStep - 1] || {}) : {}
        }
    },
    watch: {
        // Si l'utilisateur tape une étape invalide, on recale l'URL proprement
        currentStep(newVal) {
            // En mode sommaire (null) : ne rien faire
            if (newVal == null) return;
            const routeStep = this.$route.params.step ? Number(this.$route.params.step) : null;
            if (routeStep != null && newVal !== routeStep) {
                this.$router.replace({ name: 'MissionTutorial', params: { step: newVal } });
            }
        }
    },
    methods: {
        goPrev() {
            if (this.currentStep && this.currentStep > 1) {
                this.$router.push({ name: 'MissionTutorial', params: { step: this.currentStep - 1 } })
            }
        },
        goNext() {
            if (this.currentStep && this.currentStep < this.totalSteps) {
                this.$router.push({ name: 'MissionTutorial', params: { step: this.currentStep + 1 } })
            }
        },
        finish() {
            // Choisis la destination finale du tutoriel (ex: missionslist)
            this.$router.push({ name: 'MissionsList' })
        }
    }
}
</script>

<style scoped>
.tutorial-card {
    border-radius: 12px;
}

.toc-card {
    border-radius: 12px;
}

.toc-list .list-group-item {
    border-left: 3px solid #eee;
}

.toc-list .list-group-item:hover {
    background: #f9fbff;
}

.tutorial-image-wrap {
    width: 100%;
    /* hauteur “confortable” et responsive, évite la déformation */
    max-height: 85vh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: #f8f9fa;
    border: 1px solid #eee;
    border-radius: 8px;
}

.tutorial-image {
    max-width: 100%;
    max-height: 85vh;
    height: auto;
    width: auto;
    object-fit: contain;
    /* garde le ratio de l’image sans la déformer */
}
</style>
